import { render, staticRenderFns } from "./teams-button.vue?vue&type=template&id=3b0811fa"
import script from "./teams-button.vue?vue&type=script&lang=ts"
export * from "./teams-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports